import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.auth.register');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-auth-register',
template: templateSource || '',
    styles: [``],
})
export class PortalAuthRegisterComponent implements OnInit {
    @Input() redirectUrl: string = '/access';

    public data: any = { email: '', password: '', confirm_password: '', name: '' };
    public loading: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public async register() {
        if (!this.data.name) {
            await this.service.modal.error("이름을 입력해주세요.");
            return;
        }
        if (!this.data.email) {
            await this.service.modal.error("이메일을 입력해주세요.");
            return;
        }
        if (!this.data.password) {
            await this.service.modal.error("비밀번호를 입력해주세요.");
            return;
        }
        if (this.data.password.length < 8) {
            await this.service.modal.error("비밀번호는 8자 이상이어야 합니다.");
            return;
        }
        if (this.data.password !== this.data.confirm_password) {
            await this.service.modal.error("비밀번호가 일치하지 않습니다.");
            return;
        }

        this.loading = true;
        await this.service.render();

        const formData = new URLSearchParams();
        formData.append('email', this.data.email);
        formData.append('password', this.data.password);
        formData.append('name', this.data.name);

        try {
            const response = await fetch('/api/auth/register', {
                method: 'POST',
                body: formData
            });
            const result = await response.json();

            if (response.ok) {
                await this.service.modal.success("회원가입이 완료되었습니다. 로그인해주세요.");
                location.href = this.redirectUrl;
            } else {
                await this.service.modal.error(result.message || "회원가입에 실패했습니다.");
            }
        } catch (e) {
            await this.service.modal.error("서버 오류가 발생했습니다.");
        }

        this.loading = false;
        await this.service.render();
    }
}

export default PortalAuthRegisterComponent;